import { useState, useEffect } from "react";
import { useData, useDispatch } from "./DataContext.js";
import { decompress } from "compress-json";
import { CSVLink } from "react-csv";

import Modal from "react-bootstrap/Modal";
import ToggleButton from "react-bootstrap/ToggleButton";
import CloseButton from "react-bootstrap/CloseButton";
import Table from "react-bootstrap/Table";

export default function StatsModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const [byPassword, setByPassword] = useState(false);

    function hide ()
    {
	props.hide();
    }

    useEffect(() => {
	if (props.show) gDispatch({ type: "loadStats", password: gData.session.password });
    }, [props.show]);

    const playList = Object
	.values(gData.session.allPlays)
	.map((play) => {
	    const date = play.creationTime.substring(0, 7);
	    let data = { password: play.password, sessionId: play.sessionId, date };

	    //data.name = play.name;
	    data.nameNb = play.name.trim().split(/\s+/).length;

	    /* const state = decompress(JSON.parse(play.playState));
	       data.emptyState = Object.keys(state).length === 0;
	       data.badgeCount = Object.values(state.badges).filter(badge => badge.state === "opened").length;
	       data.badgeRatio = Math.round(data.badgeCount * 100 / 136); */

	    return data;
	})
    /* .filter((data) => data.badgeRatio > 50); */

    let firstDate = null;
    let lastDate = null;
    
    playList.forEach((play) => {
	if (firstDate === null || play.date < firstDate) firstDate = play.date;
	if (lastDate === null || play.date > lastDate) lastDate = play.date;
    });
    
    if (playList.length === 0) return (<></>);
    
    const firstYear = parseInt(firstDate.substring(0, 4));
    const firstMonth = parseInt(firstDate.substring(5, 7));
    const lastYear = parseInt(lastDate.substring(0, 4));
    const lastMonth = parseInt(lastDate.substring(5, 7));

    let initRowlist = {};
    let year = firstYear;
    let month = firstMonth;
    let date = year + "-" + (month < 10 ? "0" : "") + month;
    if (byPassword) initRowlist[date] = { date, passwordList: [] };
    else initRowlist[date] = { date, passwordList: [], sessionList: [], playNb: 0, nameNb: 0 };
    while (year < lastYear || month < lastMonth)
    {
	month++;
	if (month > 12) { month = 1; year++; }
	date = year + "-" + (month < 10 ? "0" : "") + month;
	if (byPassword) initRowlist[date] = { date, passwordList: [] };
	else initRowlist[date] = { date, passwordList: [], sessionList: [], playNb: 0, nameNb: 0 };
    }

    let rows = (<></>);
    let csvData = [["Date", "Identifiants", "Sessions", "Parties", "Joueurs"]];
    
    if (byPassword)
    {
	const rowList = playList.reduce((rowlist, play) => {
	    let row = rowlist[play.date];
	    if (! Object.keys(row.passwordList).includes(play.password)) row.passwordList[play.password] = { password: play.password, sessionList: [], playNb: 0, nameNb: 0 };

	    let rrow = row.passwordList[play.password];
	    if (! rrow.sessionList.includes(play.sessionId)) rrow.sessionList.push(play.sessionId);
	    rrow.playNb++;
	    rrow.nameNb += play.nameNb;	    

	    row.passwordList[play.password] = rrow;
	    rowlist[play.date] = row;
	    return rowlist;
	}, initRowlist);

	rows = Object.values(rowList).flatMap((row) => {
	    return Object.values(row.passwordList).map((rrow) => {
		const date = row.date.substring(5, 7) + "/" + row.date.substring(0, 4);
		csvData.push([date, rrow.password, rrow.sessionList.length, rrow.playNb, rrow.nameNb]);

		return (
		    <tr>
			<td>{date}</td>
			<td>{rrow.password}</td>
			<td>{rrow.sessionList.length}</td>
			<td>{rrow.playNb}</td>
			<td>{rrow.nameNb}</td>
		    </tr>
		);
	    });
	});
    }

    else {
	const rowList = playList.reduce((rowlist, play) => {
	    let row = rowlist[play.date];
	    if (! row.passwordList.includes(play.password)) row.passwordList.push(play.password);
	    if (! row.sessionList.includes(play.sessionId)) row.sessionList.push(play.sessionId);
	    row.playNb++;
	    row.nameNb += play.nameNb;	    

	    rowlist[play.date] = row;
	    return rowlist;
	}, initRowlist);

    	rows = Object.values(rowList).map((row) => {
	    const date = row.date.substring(5, 7) + "/" + row.date.substring(0, 4);		
	    csvData.push([date, row.passwordList.length, row.sessionList.length, row.playNb, row.nameNb]);

	    return (
		<tr>
		    <td>{date}</td>
		    <td>{row.passwordList.length}</td>
		    <td>{row.sessionList.length}</td>
		    <td>{row.playNb}</td>
		    <td>{row.nameNb}</td>
		</tr>
	    );
	});
    }

    const passwordList = [ ...new Set(playList.map((play) => play.password)) ];
    const sessionList = [ ...new Set(playList.map((play) => play.sessionId)) ];
    const nameNb = playList.reduce((count, play) => count += play.nameNb, 0);
    
    return (
	<Modal
	    size="xl"
	    show={props.show}
	    onHide={hide}
	    centered
	>
	    <Modal.Header className="v-100 bg-light d-flex justify-content-between align-items-center">
		<Modal.Title>Statistiques</Modal.Title>
		<div className="v-100 bg-light d-flex align-items-center gap-2">
		    <ToggleButton type="checkbox" variant="outline-dark" checked={byPassword} onClick={() => setByPassword(!byPassword)}>Montrer les identifiants</ToggleButton>
		    <CSVLink className="btn btn-dark" filename="enquete-cybersecurite-statistiques.csv" data={csvData}>
			Exporter en CSV
		    </CSVLink>
		    <CloseButton onClick={hide}/>
		</div>
	    </Modal.Header>
	    <Modal.Body>
		<Table bordered variant="light" className="text-end" style={{ width: "" }}>
		    <thead>
			<tr>
			    <td className="bg-dark text-light"></td>
			    <td className="bg-dark text-light text-uppercase">Identifiants</td>
			    <td className="bg-dark text-light text-uppercase">Sessions</td>
			    <td className="bg-dark text-light text-uppercase">Parties</td>
			    <td className="bg-dark text-light text-uppercase">Joueur·euses</td>
			</tr>
			<tr>
			    <td className="bg-dark text-light text-uppercase">Total</td>
			    <td className="bg-dark text-light">{passwordList.length}</td>
			    <td className="bg-dark text-light">{sessionList.length}</td>
			    <td className="bg-dark text-light">{playList.length}</td>
			    <td className="bg-dark text-light">{nameNb}</td>
			</tr>
		    </thead>
		    <tbody>{rows}</tbody>
		</Table>
	    </Modal.Body>
	</Modal>
    );
}

